import React, { Suspense, useEffect } from 'react'
import { Toaster } from 'react-hot-toast'
import { BrowserRouter, Route, Routes } from 'react-router-dom'

import { CSpinner } from '@coreui/react-pro'
import AxiosInterceptors from 'components/interceptors/AxiosInterceptors'
import { caching } from 'utils/caching'
import { toastConfig, toastContainerStyles } from 'utils/configs/toast'
import ScrollToTop from 'views/common/ScrollTop'
import SettingPassword from 'views/setting-password/SettingPassword'

import './scss/style.scss'

// Containers
const DefaultLayout = React.lazy(() => import('./layout/DefaultLayout'))
const Login = React.lazy(() => import('./views/login/Login'))
const ForgotPassword = React.lazy(
  () => import('./views/forgot-password/ForgotPassword'),
)
const ResetPassword = React.lazy(
  () => import('./views/reset-password/ResetPassword'),
)
const ChangeEmailError = React.lazy(() => import('./views/error/ChangeEmail'))
const FaqScreen = React.lazy(() => import('./views/faq/FaqScreen'))
const Maintenance = React.lazy(() => import('./views/maintenance/Maintenance'))
const Impersonate = React.lazy(() => import('./views/impersonate/Impersonate'))

const App = () => {
  useEffect(() => {
    caching()
  }, [])
  if (process.env.REACT_APP_STATUS_MAINTENANCE === 'true') {
    return (
      <BrowserRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <Routes>
            <Route path="*" element={<Maintenance />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
    )
  }
  return (
    <>
      <BrowserRouter>
        <Suspense fallback={<CSpinner color="primary" />}>
          <ScrollToTop />
          <AxiosInterceptors>
            <Routes>
              <Route path="*" element={<DefaultLayout />} />
              <Route path="/login" element={<Login />} />
              <Route path="/forgot-password" element={<ForgotPassword />} />
              <Route path="/reset-password" element={<ResetPassword />} />
              <Route path="/change-email" element={<ChangeEmailError />} />
              <Route path="/faq" element={<FaqScreen />} />
              <Route path="/setting-password" element={<SettingPassword />} />
              <Route path="/impersonate" element={<Impersonate />} />
            </Routes>
          </AxiosInterceptors>
        </Suspense>
      </BrowserRouter>
      <Toaster
        toastOptions={toastConfig}
        containerStyle={toastContainerStyles}
      />
    </>
  )
}

export default App
